//react
import { useEffect, useState } from 'react'
//components
import List from './List'
import CloseIcon from '@mui/icons-material/CloseOutlined'
import CustomButton from '../../../../../ui/CustomButton'

const BancosTableInsights = ({ setConnectBank, dataSaldo }) => {
  const [acounts] = useState([])
  //const [acounts, setAcounts] = useState([])
  const [currentAcount] = useState(acounts[0] || null)
  const [selectedBank, setSelectedBank] = useState('')
  const [showPopup, setShowPopup] = useState(false)
  const [showDisconnect, setShowDisconnect] = useState(false)
  //const [, setAccountToDisconnect] = useState(null)

  useEffect(() => {
    if ((!dataSaldo?.data || dataSaldo.data.length === 0) && !selectedBank) {
      setSelectedBank('')
    }
  }, [dataSaldo])

  return (
    <>
      <List
        currentAcount={currentAcount}
        dataSaldo={dataSaldo}
      />
    {showPopup && (
      <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50'>
        <div className='relative bg-white px-8 py-6 rounded-xl shadow-2xl w-[400px] text-center'>
        <button
            onClick={() => setShowPopup(false)}
            className='absolute top-2 right-2 text-gray-400 hover:text-gray-600'
          >
            <CloseIcon />
          </button>
          <div className='flex justify-center mb-4'>
            <div className='w-16 h-16 border-2 border-red-500 rounded-full flex items-center justify-center'>
              <span className='text-red-500 text-4xl'>!</span>
            </div>
          </div>
          <h2 className='font-sans text-lg text-gray-800 font-semibold'>
            Ya tienes una cuenta vinculada.
          </h2>
          <p className='font-sans text-sm text-gray-500 mt-2'>
            Si deseas agregar una nueva cuenta, contactarse con el equipo de Luca.
          </p>
        </div>
      </div>
    )}
    {showDisconnect && (
      <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50'>
        <div className='relative bg-white px-8 py-6 rounded-xl shadow-2xl w-[400px] text-center'>
          <div className='flex justify-center mb-4'>
            <div className='w-16 h-16 border-2 border-red-500 rounded-full flex items-center justify-center'>
              <span className='text-red-500 text-4xl'>!</span>
            </div>
          </div>
          <h2 className='font-sans text-lg text-gray-800 font-semibold'>
            ¿Estás seguro de desconectar esta cuenta de banco?
          </h2>
          <p className='font-sans text-sm text-gray-500 mt-2'>
            Esta acción se realizada dentro de las proximas 24 horas.
          </p>
          <div className='flex justify-center gap-4 mt-6'>
            <CustomButton onClick={() => setShowDisconnect(false)}  className='rounded-full' title='Cancelar' color='primary'/>
            <CustomButton className='rounded-full' title='Desconectar' color='accent3'/>
          </div>
        </div>
      </div>
    )}
  </>
  )
}

export default BancosTableInsights
